export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-05.e0f231a4.svg";